import { useContext } from "react";
import * as selectors from "@/selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { CompanyContext } from "../CompanyList/CompanyContext";

// From Columns.jsx & `isMultiLine` is not ported
const formatSuperscriptAsterisk = (value) => {
	if (typeof value !== "string") return value;

	// Check if the value ends with an asterisk variation
	// \u204E -> low asterisk
	// \u002A -> regular keyboard asterisk
	const hasAsterisk = value.trimEnd().match(/[*\u204E\u002A]$/);

	if (hasAsterisk) {
		return (
			<>
				{value.slice(0, -1)}
				<sup>*</sup>
			</>
		);
	}

	return value;
};

export const BaseColumnInformation = ({ classNames, style, ...props }) => {
	const { company } = useContext(CompanyContext);
	const columnInformation = useSelector((state) =>
		selectors.getColumnInformation(state, { company }),
	);

	if (!columnInformation) return null;

	return (
		<div
			style={{
				gridTemplateColumns: `repeat(${columnInformation.length}, 1fr)`,
				...style,
			}}
			{...props}
			className={classNames?.wrapper}
		>
			{columnInformation.map((column, idx) => {
				const columnValue = column.value;
				const isStringColumnValue = typeof columnValue === "string";
				const isMultiLine = isStringColumnValue
					? columnValue.includes("\\n")
					: false;

				return (
					<div key={idx} className={classNames?.columnWrapper}>
						{column?.icon && (
							<img
								src={column?.icon}
								alt={column?.label}
								className={classNames?.icon}
							/>
						)}

						<div className={classNames?.column}>
							<div className={classNames?.label}>{column.label}</div>

							{isMultiLine ? (
								<div className={classNames?.value}>
									{columnValue.split("\\n").map((multilineColVal, line) => (
										<div key={line}>
											{formatSuperscriptAsterisk(multilineColVal)}
										</div>
									))}
								</div>
							) : (
								<div className={classNames?.value}>
									{formatSuperscriptAsterisk(column.value)}
								</div>
							)}
						</div>
					</div>
				);
			})}
		</div>
	);
};

BaseColumnInformation.propTypes = {
	classNames: PropTypes.shape({
		wrapper: PropTypes.string,
		columnWrapper: PropTypes.string,
		column: PropTypes.string,
		label: PropTypes.string,
		icon: PropTypes.string,
		value: PropTypes.string,
	}),
	icon: PropTypes.element,
	style: PropTypes.object,
};
